import { c as _c } from "react/compiler-runtime";
import { iconSize } from '@cc-shopping/ui/theme';
import type { SVGAttributes } from 'react';
type PlayMediaIconProps = SVGAttributes<SVGSVGElement> & {
  size: string;
  color: string;
};
export function PlayMediaIcon(t0) {
  const $ = _c(13);
  let props;
  let size;
  let t1;
  if ($[0] !== t0) {
    ({
      size,
      color: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = size;
    $[3] = t1;
  } else {
    props = $[1];
    size = $[2];
    t1 = $[3];
  }
  const color = t1 === undefined ? "currentcolor" : t1;
  let t2;
  if ($[4] !== size) {
    t2 = iconSize(size);
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const resolvedSize = t2;
  let t3;
  if ($[6] !== color || $[7] !== props || $[8] !== resolvedSize) {
    t3 = {
      fill: color,
      focusable: false,
      width: resolvedSize,
      height: resolvedSize,
      ...props
    };
    $[6] = color;
    $[7] = props;
    $[8] = resolvedSize;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const svgProps = t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path d="M12.281 7.202c.313.182.469.45.469.8 0 .352-.156.619-.469.8l-6.875 4.061c-.3.183-.612.183-.937 0-.313-.169-.469-.436-.469-.8v-8.12c0-.391.163-.665.488-.82.339-.17.645-.163.918.019l6.875 4.06z" />;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== svgProps) {
    t5 = <svg viewBox="0 0 16 16" aria-hidden={true} {...svgProps}>{t4}</svg>;
    $[11] = svgProps;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}